import { ActionTypes } from "../../constants";
import { combineReducers } from "redux";
import { idAsNumber } from "../../utilities/reducers";


const formatCategory = (({id, subcategories, ...category}) => ({
    id: Number(id),
    ...category,
    subcategories: subcategories.map(idAsNumber)
}));

const reduceCategories = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_JP_ACTIVITY_CATEGORY_LIST_SUCCESS:
            return action.data.map(formatCategory);

        default:
            return state;
    }
};

const reduceActivityTypes = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_JP_ACTIVITY_TYPE_LIST_SUCCESS:
            return action.data;

        default:
            return state;
    }
};

const reduceLocations = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_JP_LOCATION_LIST_SUCCESS:
            return action.data.map(idAsNumber);

        default:
            return state;
    }
};

const reduceObjectives = (state = [], action) => {
    switch (action.type) {
        case ActionTypes.GET_JP_ACTIVITY_OBJECTIVE_LIST_SUCCESS:
            return action.data;

        case ActionTypes.GET_JP_ACTIVITY_OBJECTIVE_LIST_FAILURE:
            return [];

        default:
            return state;
    }
};

const activities = combineReducers({
    categories: reduceCategories,
    types: reduceActivityTypes,
    locations: reduceLocations,
    objectives: reduceObjectives
})

export default activities;

export const getCategories = ({categories}) => categories || [];

export const getTypes = ({types}) => types || [];
export const getType = ({types}, id) => types.find(type => id === type.id);
export const getTypeByCode = ({types}, code) => types.find(type => code === type.code);
export const getLocations = ({locations}) => locations || [];
export const getObjectives = ({objectives}) => objectives || [];
